// Import asset images
import './images';

// Import javascript
// import debounce from './helpers/debounce';

import siteMenu from './partials/siteMenu';
import sliders from './partials/sliders';
import buttons from './partials/buttons';
import combos from './partials/combo';
import forms from './partials/form';
import scroll from './partials/scroll';
import animation from './partials/animations';
import analytics from './partials/analytics';

document.addEventListener('DOMContentLoaded', async function () {
  siteMenu();
  analytics();
  sliders();
  buttons();
  forms();
  combos();
  scroll();
  animation();

  window.addEventListener('resize', function () {
    document.documentElement.style.setProperty(
      '--vh',
      window.innerHeight * 0.01 + 'px'
    );
  });
});
